import styles from "../AudioRecorder.module.scss";

const RecordingStatus = ({
  recordingError,
  isPaused,
  isRecordingFinished,
  isRecordingStarted,
}) => {
  if (recordingError) return null;

  if (isPaused) {
    return <div>Paused</div>;
  }

  if (isRecordingFinished) {
    return <div className={styles["audio-recorder__recording-icon-paused"]} />;
  }

  if (isRecordingStarted) {
    return (
      <>
        <div className={styles["audio-recorder__recording-icon"]} />
        <div>Recording</div>
      </>
    );
  }

  return (
    <>
      <div className={styles["audio-recorder__recording-icon-paused"]} />
      <div>Ready to record</div>
    </>
  );
};

export default RecordingStatus;
